interface TableHeaderProps {
  text: string;
}

export const TableHeader = ({ text }: TableHeaderProps) => {
  return (
    <div className="flex items-center gap-2">
      <div className="text-primary text-[13px] font-extrabold">{text}</div>
    </div>
  );
};
